import { Button, ButtonSize, ButtonVariant } from "shared/components";
import type { VoicemailHeardResponse } from "api/voice";
import { useMarkVoicemailHeard } from "shared/hooks/use-mark-voicemail-heard";
import { MARK_AS_HEARD_LABEL } from "./voicemail";

/** CRM-1777: clears a New voicemail for the whole team, like a first play. */
export const MarkVoicemailHeardButton = ({
  callId,
  onHeard
}: {
  callId: number | string;
  onHeard: (response: VoicemailHeardResponse) => void;
}) => {
  const { markHeard, isPending } = useMarkVoicemailHeard(callId, { onHeard });

  return (
    <Button
      variant={ButtonVariant.TEXT}
      size={ButtonSize.SM}
      loading={isPending}
      loadingMode="keep-label"
      disabled={isPending}
      onClick={markHeard}
    >
      {MARK_AS_HEARD_LABEL}
    </Button>
  );
};
